import React from "react";
import { Asset, Link } from "../../../../plugins/gatsby-plugin-atollon";
import { graphql } from "gatsby";
import {
    EdlynLogo,
    SunnySideLogo,
    WoodsLogo,
    GreenWheatLogo,
    WoodsBasicLogo,
    BoneLogo,
} from '../../icons'


const LinkTree = ({ image, links, theme }) => {
    return (
        <section className={`link-tree ${theme}`}>
            <div className="link-tree__inner">
                <div className="link-tree__logo">
                    <Link to={
                        (() => {
                            switch (theme) {
                                case "edlyn":
                                    return "/edlyn/"
                                case "woods":
                                    return "/woods/"
                                case "bone":
                                    return "/bone-roasters/"
                                case "greenwheat":
                                    return "/greenwheat-freekeh/"
                                case "sunnyside":
                                    return "/sunnyside/"
                                default:
                                    return "/"
                            }
                        })()
                    }>
                        {(() => {
                            switch (theme) {
                                case "woods":
                                    return <WoodsBasicLogo />
                                case "bone":
                                    return <BoneLogo />
                                case "greenwheat":
                                    return <GreenWheatLogo />
                                case "sunnyside":
                                    return <SunnySideLogo color='#FD5C3F' />
                                default:
                                    return <EdlynLogo />
                            }
                        })()
                        }
                    </Link>
                </div>
                <div className="link-tree__buttons">
                    {links?.length > 0 && links.map((link, index) => (
                        <Link
                            key={index}
                            to={link.link[0].externalLink ? link.link[0].externalLink : link.link[0].internalLink?.permalink}
                        >
                            {link.title}
                        </Link>
                    ))}
                </div>
            </div>
            <div className="link-tree__image">
                {image && <Asset asset={image} />}
            </div>
        </section>
    );
};

export default LinkTree;

export const query = graphql`
  fragment LinktreeProps on DatoCmsLinktree {
    ... on DatoCmsLinktree {
      image {
        ...InternalAssetProps
      }
      links {
        ...LinkWithTitleProps
      }
    }
  }
`